import {connect} from "react-redux";
import {Dispatch} from "react";
import actions from "../redux/actions/Index";
import {ICreateAgentOnlyReq, ICreateUpdateAgentManagementUserNormalizedReq, IGetQueryParams} from "../interfaces/Index";
import AgentManagementPage from "../components/pages/agentManagement/AgentManagementPage";

export const mapStateToProps = (state: any, props: any) => {
  const { zone } = state;
  return {
    isLoading: state.agentManagement.isLoading,
    isError: state.agentManagement.isError,
    error: state.agentManagement.error,
    isAgentManagementUserAdded:
      state.agentManagement.isAgentManagementUserAdded,
    agentManagementUsers: state.agentManagement.agentManagementUsers,
    pagination: state.agentManagement.pagination,
    isagentManagementUserDetailsNewFetched:
      state.agentManagement.isagentManagementUserDetailsNewFetched,
    agentManagementUserDetailsNew:
      state.agentManagement.agentManagementUserDetailsNew,
    isAgentManagementUserUpdated:
      state.agentManagement.isAgentManagementUserUpdated,
    allClientsRoles: state.agentManagement.allClientsRoles,
    isAllClientsRolesFetched: state.agentManagement.isAllClientsRolesFetched,
    userInfo: state.userAuth.userInfo,
    agentTitle: state.agentManagement.agentTitle,
    agentTeam: state.agentManagement.agentTeam,
    customerConfig: state.customer.customerConfig,
    allAgentZones: state.agentManagement.allAgentZones,
    isAllAgentZonesFetched: state.agentManagement.isAllAgentZonesFetched,
    bulkCustomerDetails: state.customer.bulkCustomerDetails,
    isBulkCustomerDetailsFetched: state.customer.isBulkCustomerDetailsFetched,
    citiesList: zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
    brands: state.agentManagement.brands,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    getAgentList: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getAgentListAction(queryPrams)),
    getUpdateAgentDetail: (id: string) =>
      dispatch(actions.getAgentDetailAction(id)),
    getAllAgentZones: (selectedCity?: string, customerChannel?: string, queryPrams?: IGetQueryParams) =>
      dispatch(actions.getAllAgentZonesAction(selectedCity,customerChannel, queryPrams)),
    createAgentWithTypeTeamZones: (payload: ICreateAgentOnlyReq) => dispatch(actions.createAgentWithTypeTeamZones(payload)),
    createAgentUserWithTypeTeamZones: (
      payload: ICreateUpdateAgentManagementUserNormalizedReq
    ) => dispatch(actions.createAgentUserWithTypeTeamZones(payload)),
    updateAgentUserWithTypeTeamZones: (
      payload: ICreateUpdateAgentManagementUserNormalizedReq
    ) => dispatch(actions.updateAgentUserWithTypeTeamZones(payload)),
    fetchAgentTitle: () => dispatch(actions.fetchAgentTitle()),
    fetchAgentTeam: () => dispatch(actions.fetchAgentTeam()),
    fetchBrands: () => dispatch(actions.fetchBrands()),
    fetchCustomerConfig: () => dispatch(actions.fetchCustomerConfig()),
    getBulkCustomerDetailsByIdAction: (ids: string[]) =>
      dispatch(actions.getBulkCustomerDetailsByIdAction(ids)),
    clearBulkCustomerDetailsAction: () =>
      dispatch(actions.clearBulkCustomerDetailsAction()),
  };
};

const AgentManagementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentManagementPage);
export default AgentManagementContainer;
